import {useCallback, useState} from 'react'

import {listRelatedAdsContactTypes} from '@adv-mt/mt-list-related-ads'

import {NOTIFICATIONS} from '../notifications.js'

const useContactHandlers = ({
  leadErrorHitInformations,
  notify,
  onLeadContact,
  trackLeadError,
  triggerPostContactModal
}) => {
  const [autoGeneratedPassword, setAutoGeneratedPassword] = useState(null)

  const onContact = useCallback(
    payload => {
      onLeadContact(payload)

      if (payload?.userHasBeenRegistered && payload?.autoGeneratedPassword) {
        setAutoGeneratedPassword(payload.autoGeneratedPassword)
      }

      triggerPostContactModal({...payload, contactType: listRelatedAdsContactTypes.email})
    },
    [onLeadContact, triggerPostContactModal]
  )

  const onPhoneLead = useCallback(
    () => triggerPostContactModal({contactType: listRelatedAdsContactTypes.phoneCall}),
    [triggerPostContactModal]
  )

  const handleWhatsappError = useCallback(() => notify(NOTIFICATIONS.WHATSAPP_LEAD_ERROR), [notify])

  const handleSubmitError = useCallback(() => {
    notify(NOTIFICATIONS.CONTACT_FORM_SUBMIT_ERROR)
    trackLeadError(leadErrorHitInformations.MESSAGE_NOT_SENT)
  }, [notify, trackLeadError, leadErrorHitInformations])

  const handleLeadError = useCallback(({hitInformation} = {}) => trackLeadError(hitInformation), [trackLeadError])

  const clearAutoGeneratedPassword = useCallback(() => setAutoGeneratedPassword(null), [])

  return {
    autoGeneratedPassword,
    clearAutoGeneratedPassword,
    handleLeadError,
    handleSubmitError,
    handleWhatsappError,
    onContact,
    onPhoneLead
  }
}

export default useContactHandlers
